import React from 'react';

import { SxProps } from '@mui/material';

import TAGLink from '@/components/TAGLink';

interface CCNavLinkProps extends React.ComponentProps<typeof TAGLink> {
	sx?: SxProps;
}

/**
 * ClearChoice Navigation Link Component
 * Uses noLinkStyle to render plain anchor tags without MUI Link styling
 * Avoids underline issues with external URLs
 */
export const CCNavLink = ({ sx, ...props }: CCNavLinkProps) => (
	<TAGLink
		{...props}
		noLinkStyle={true}
		linkSx={{
			textDecoration: 'none',
			color: 'inherit',
			...sx,
		}}
	/>
);

export default CCNavLink;
